(function (module) {
    "use strict";

    module.service("volumeToValueService", [
        "synchronousEventsBus",
        "forecastCacheService",
        "$q",
        function (this: $TSFixMe, synchronousEventsBus: $TSFixMe, forecastCacheService: $TSFixMe, $q: ng.IQService) {
            function isMarketForecast(forecast: $TSFixMe, parameters: $TSFixMe) {
                return (
                    _.contains(["sku", "mktsh"], parameters.forecastMethod.methodId) &&
                    angular.equals(forecastCacheService.getForecast().market.forecast, forecast)
                );
            }

            var service = this;
            service.registerEvents = function () {
                synchronousEventsBus.$on("regressionCalculated", function (e: $TSFixMe, args: $TSFixMe) {
                    if (isMarketForecast(args.forecast, args.parameters)) {
                        return service.priceChangeInYearsChanged(args.forecast, args.parameters);
                    }
                });

                synchronousEventsBus.$on("pmForecastChanged", function (e: $TSFixMe, args: $TSFixMe) {
                    if (isMarketForecast(args.forecast, args.parameters)) {
                        return service.priceChangeInYearsChanged(args.forecast, args.parameters);
                    }
                });
            };

            service.priceChangeInYearsChanged = function (forecast: $TSFixMe, parameters: $TSFixMe) {
                var promises = [];

                if (angular.isUndefinedOrNull(forecast.value)) {
                    forecast.value = {};
                }

                if (!angular.isUndefinedOrNull(forecast.statisticalForecast)) {
                    forecast.value.statisticalForecast = service.calculateValueInMonths(
                        _.last(forecast.yearlyAveragePrice).averagePrice,
                        forecast.statisticalForecast,
                        forecast.priceChangeInYears,
                        parameters.forecastStartDate,
                        parameters.forecastEndDate,
                        parameters.forecastType.typeId
                    );
                    promises.push(
                        synchronousEventsBus.$broadcast("value.statisticalForecastChanged", {
                            forecast: forecast,
                            parameters: parameters
                        })
                    );
                }

                if (!angular.isUndefinedOrNull(forecast.pmForecast)) {
                    forecast.value.pmForecast = service.calculateValueInMonths(
                        _.last(forecast.yearlyAveragePrice).averagePrice,
                        forecast.pmForecast,
                        forecast.priceChangeInYears,
                        parameters.forecastStartDate,
                        parameters.forecastEndDate,
                        parameters.forecastType.typeId
                    );
                    promises.push(
                        synchronousEventsBus.$broadcast("value.pmForecastChanged", {
                            forecast: forecast,
                            parameters: parameters
                        })
                    );
                }

                return $q.all(promises);
            };

            service.calculateValueInMonths = function (
                historicalAveragePrice: $TSFixMe,
                volume: $TSFixMe,
                priceChangeInYears: $TSFixMe,
                forecastStartDate: $TSFixMe,
                forecastEndDate: $TSFixMe,
                forecastTypeId: $TSFixMe
            ) {
                var result = [];

                var startYear = parseInt(moment(forecastStartDate).format("YYYY"));

                var date = moment(forecastStartDate);

                var averagePriceInYears: $TSFixMe = [];

                for (var i = 0; i < volume.length; i++) {
                    var year = parseInt(date.format("YYYY"));
                    var yearIndex = year - startYear;

                    if (yearIndex >= averagePriceInYears.length) {
                        averagePriceInYears[yearIndex] =
                            ((yearIndex > 0 ? averagePriceInYears[yearIndex - 1] : historicalAveragePrice) *
                                (100 + priceChangeInYears[yearIndex])) /
                            100.0;
                    }

                    result.push(volume[i] * averagePriceInYears[yearIndex]);
                    date = date.add(1, "months");
                }
                return result;
            };

            service.calculateAveragePrices = function (lastHistoricalPrice: $TSFixMe, priceChangesInYears: $TSFixMe) {
                const prices = [];
                for (let priceChange of priceChangesInYears) {
                    // @ts-expect-error ts-migrate(7022) FIXME: 'previousPrice' implicitly has type 'any' because ... Remove this comment to see the full error message
                    const previousPrice = _.last(prices) || lastHistoricalPrice;
                    prices.push(previousPrice * (1 + priceChange / 100));
                }

                return prices;
            };
        }
    ]);
    module.run([
        "volumeToValueService",
        function (service: $TSFixMe) {
            service.registerEvents();
        }
    ]);
})(angular.module("topline.services"));
